module.exports = __webpack_public_path__ + "img/x-center.b322c251.svg";